import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';
import { MessageService } from '../shared/message.service';

@Injectable({
  providedIn: 'root'
})
export class PriceManagementFilterService {

  gridFilterModel = {};
  tabModel = {
    activeTab: 'AllItems',
    activeSubTab: 'AllItems',
  }
  //store filterModelFromGrid everytime model changes on grid
  //when a tab is clicked, the deptCode, isStock, etc.  will be added and sent back to the grid
  filterModelFromGrid: any = {};
  quickFilterText = '';
  nameOfItemFilterToApplyAfterLoadingItems: string = '';

  tabModel$: Observable<any>;
  gridFilterModel$: Observable<any>;

  //need BehaviorSubject so that it sends stored value even if no change
  private _tabModelSubject = new BehaviorSubject<any>(this.tabModel);
  private _gridFilterModelSubject = new BehaviorSubject<any>(this.gridFilterModel);

  constructor(
    private _messageService: MessageService,
  ) {
    this.tabModel$ = this._tabModelSubject.asObservable();
    this.gridFilterModel$ = this._gridFilterModelSubject.asObservable();
  }

  getGridFilterModel(){
    return this.filterModelFromGrid;
  }

  getTabModel(){
    return this.tabModel;
  }

  // Sets tab model and appearance of tabs but doesn't append to gridFilterModel
  setTabModel(tabModel){
    this.tabModel = tabModel;
    this._tabModelSubject.next(tabModel);
  }

  setGridFilterModel(filterModelFromGrid){
    this.filterModelFromGrid = this.removePropertiesNotBeingFilteredFromGridFilterModel(filterModelFromGrid);
  }

  // Sets tab model and appends to gridFilterModel which filters grid
  // This is used on tab clicks
  setGridFilterModelFromTabModel(tabModel){
    this.setTabModel(tabModel);
    this.gridFilterModel = this.appendTabFiltersToGridFilterModel(this.filterModelFromGrid, this.tabModel);
    this._gridFilterModelSubject.next(this.gridFilterModel);
    //console.log(this.gridFilterModel);
    this.showCurrentFiltersThatAreApplied(this.gridFilterModel);
  }

  setQuickFilterText(quickFilterText){
    this.quickFilterText = quickFilterText;
  }

  getNameOfItemFilterToApplyAfterLoadingItems(){
    return this.nameOfItemFilterToApplyAfterLoadingItems;
  }

  setNameOfItemFilterToApplyAfterLoadingItems(itemFilterName){
    this.nameOfItemFilterToApplyAfterLoadingItems = itemFilterName;
  }

  updateSubscribersToGridFilterModel(){
    this._gridFilterModelSubject.next(this.gridFilterModel);
  }

  //GAIR-203
    appendTabFiltersToGridFilterModel(filterModelFromGrid, tabModel){
    
    // Remove properties that are set by tab clicks
    if (filterModelFromGrid.hasOwnProperty('deptCode')) delete filterModelFromGrid.deptCode;
    if (filterModelFromGrid.hasOwnProperty('isPreview')) delete filterModelFromGrid.isPreview;
    if (filterModelFromGrid.hasOwnProperty('isStock')) delete filterModelFromGrid.isStock;
    if (filterModelFromGrid.hasOwnProperty('catchWeight')) delete filterModelFromGrid.catchWeight;

    filterModelFromGrid.isPreview = {
      filterType: 'set',
      values: ['false'],
    }

    filterModelFromGrid.catchWeight = {
      filterType: 'set',
      values: ['false'],
    }
    
    //Active Tab
    switch (tabModel.activeTab) {
      case 'AllItems':
        filterModelFromGrid.catchWeight = {
          filterType: 'set',
          values: ['true', 'false'],
        }
        break;
      case 'Grocery':
        filterModelFromGrid.deptCode = {
          filterType: 'set',
          values: ['A', 'B', 'C', 'E', 'K'],
        }
        break;
      case 'Meat':
        filterModelFromGrid.deptCode = {
          filterType: 'set',
          values: ['M', 'N'],
        }
        break;
      case 'CWMeat':
        filterModelFromGrid.catchWeight = {
          filterType: 'set',
          values: ['true'],
        }
        filterModelFromGrid.deptCode = {
          filterType: 'set',
          values: ['M', 'N'],
        }
        break;
      case 'Produce':
        filterModelFromGrid.deptCode = {
          filterType: 'set',
          values: ['P'],
        }
        break;
      case 'DeliBakery':
        filterModelFromGrid.deptCode = {
          filterType: 'set',
          values: ['S', 'X', 'Z'], 
        }
        break;
      case 'Dairy':
        filterModelFromGrid.deptCode = {
          filterType: 'set',
          values: ['D'],
        }
        break;
      case 'HBA':
        filterModelFromGrid.deptCode = {
          filterType: 'set',
          values: ['G', 'H', 'I'],
        }
        break;
      case 'FrozenFood':
        filterModelFromGrid.deptCode = {
          filterType: 'set',
          values: ['F'],
        }
        break;
      case 'Preview':
        filterModelFromGrid.isPreview = {
          filterType: 'set',
          values: ['true'],
        }
        break;
      default:
    }

    //ActiveSubTab
    switch (tabModel.activeSubTab) {
      case 'StockItems':
        filterModelFromGrid.isStock = {
          filterType: 'set',
          values: ['true'],
        } 
        break;
      case 'NonStockItems':
        filterModelFromGrid.isStock = {
          filterType: 'set',
          values: ['false'],
        } 
        break;
      case 'GroceryPreviewItems':
        filterModelFromGrid.deptCode = {
          filterType: 'set',
          values: ['A', 'B', 'C', 'K', 'S', 'X', 'Z', 'D', 'E', 'G', 'H', 'I', 'F'],
        }
        break;
      case 'MeatPreviewItems':
        filterModelFromGrid.deptCode = {
          filterType: 'set',
          values: ['M', 'N'],
        }
        break;
      case 'CWMeatPreviewItems':
        filterModelFromGrid.catchWeight = {
          filterType: 'set',
          values: ['true'],
        }
        filterModelFromGrid.deptCode = {
          filterType: 'set',
          values: ['M', 'N'],
        }
        break;
      case 'ProducePreviewItems':
        filterModelFromGrid.deptCode = {
          filterType: 'set',
          values: ['P'],
        }
        break;
      default:
        
    }
    return filterModelFromGrid;
  }

  //Reworked in GAIR-203
  // appendTabFiltersToGridFilterModel(filterModelFromGrid, tabModel){
  //   // activeTab
  //   if (filterModelFromGrid.hasOwnProperty('deptCode')) delete filterModelFromGrid.deptCode;
  //   if (filterModelFromGrid.hasOwnProperty('isPreview')) delete filterModelFromGrid.isPreview;
  //   var tabValueArray = this.getValuesForActiveTabFilter(tabModel.activeTab);
  //   if (tabValueArray.length > 0){
  //     if (tabValueArray[0] === 'PREVIEW'){
  //       filterModelFromGrid.isPreview = {
  //         filterType: 'set',
  //         values: ['true'],
  //       }
  //     }
  //     //GAIR-203
  //     //Handle special case where more than dept code is being filtered on for the Active tab.
  //     //For future cases, this might be reworked so that tabValueArray is a model with properties rather than an array of Dept Codes.
  //     else if (tabValueArray[0] === 'CWMEAT') {
  //       filterModelFromGrid.catchWeight = {
  //         filterType: 'set',
  //         values: ['true'],
  //       }
  //       filterModelFromGrid.deptCode = {
  //         filterType: 'set',
  //         values: ['M', 'N'],
  //       }
  //     }
  //     else{
  //       filterModelFromGrid.isPreview = {
  //         filterType: 'set',
  //         values: ['false'],
  //       }
  //       filterModelFromGrid.deptCode = {
  //         filterType: 'set',
  //         values: tabValueArray,
  //       }
  //     }
  //   }
  //   else { // All Depts Tab
  //     filterModelFromGrid.isPreview = {
  //       filterType: 'set',
  //       values: ['false'],
  //     }
  //   }

  //   //active subTab
  //   if (filterModelFromGrid.hasOwnProperty('isStock')) delete filterModelFromGrid.isStock;
  //   var subTabValueArray = this.getValuesForActiveSubTabFilter(tabModel.activeSubTab);
  //   if (subTabValueArray.length > 0){
  //     if (subTabValueArray[0] === 'true' || subTabValueArray[0] === 'false'){
  //       filterModelFromGrid.isStock = {
  //         filterType: 'set',
  //         values: subTabValueArray,
  //       }
  //     }
  //     else{
  //       filterModelFromGrid.deptCode = {
  //         filterType: 'set',
  //         values: subTabValueArray,
  //       }
  //     }
  //   }
  //   return filterModelFromGrid;
  // }

  //Reworked in GAIR-203
  // getValuesForActiveTabFilter(activeTab) {
  //   var valuesArray = [];
  //   switch (activeTab) {
  //     case 'AllItems':
  //       valuesArray = [];
  //       break;
  //     case 'Grocery':
  //       valuesArray = ['A', 'B', 'C', 'E', 'K'];
  //       break;
  //     case 'Meat':
  //       valuesArray = ['M', 'N'];
  //       break;
  //     case 'CWMeat':
  //       valuesArray = ['CWMEAT'];
  //       break;
  //     case 'Produce':
  //       valuesArray = ['P'];
  //       break;
  //     case 'DeliBakery':
  //       valuesArray = ['S', 'X', 'Z']; 
  //       break;
  //     case 'Dairy':
  //       valuesArray = ['D'];
  //       break;
  //     case 'HBA':
  //       valuesArray = ['G', 'H', 'I'];
  //       break;
  //     case 'FrozenFood':
  //       valuesArray = ['F'];
  //       break;
  //     case 'Preview':
  //       valuesArray = ['PREVIEW'];
  //       break;
  //     default:
  //       valuesArray = [];
  //   }
  //   return valuesArray;
  // }

  // getValuesForActiveSubTabFilter(activeSubTab) {
  //   var valuesArray = [];
  //   switch (activeSubTab) {
  //     case 'StockItems':
  //       valuesArray = ['true'];
  //       break;
  //     case 'NonStockItems':
  //       valuesArray = ['false'];
  //       break;
  //     case 'GroceryPreviewItems':
  //       valuesArray = ['A', 'B', 'C', 'K', 'S', 'X', 'Z', 'D', 'E', 'G', 'H', 'I', 'F'];
  //       break;
  //     case 'MeatPreviewItems':
  //       valuesArray = ['M', 'N'];
  //       break;
  //     case 'ProducePreviewItems':
  //       valuesArray = ['P'];
  //       break;
  //     default:
  //       valuesArray = [];
  //   }
  //   return valuesArray;
  // }

  // for highlight clear filters button
  testIfFilterApplied(){
    if (this.filterModelFromGrid){
      var keys = Object.keys(this.filterModelFromGrid);
      for (var i=0; i<keys.length; i++){
        if (keys[i] != 'deptCode' && keys[i] != 'isStock' && keys[i] != 'isPreview' && keys[i] != 'catchWeight'){
          if (this.filterModelFromGrid[keys[i]].hasOwnProperty('filter') && this.filterModelFromGrid[keys[i]].filter != '' && this.filterModelFromGrid[keys[i]].filter != null){
            return true;
          }
          // set filter is set
          else if (this.filterModelFromGrid[keys[i]].hasOwnProperty('values') && this.filterModelFromGrid[keys[i]].values.length > 0){
            return true;
          }
          // item list filter is set
          else if (keys[i] == 'itemLists' && this.filterModelFromGrid[keys[i]].hasOwnProperty('value')){
            return true;
          }
          // the grid's new multi value conditional filters with AND and OR
          else if (this.filterModelFromGrid[keys[i]].hasOwnProperty('condition1') && this.filterModelFromGrid[keys[i]].condition1.hasOwnProperty('filter') && this.filterModelFromGrid[keys[i]].condition1.filter != '' && this.filterModelFromGrid[keys[i]].condition1.filter != null){
            return true;
          }
        } 
      }
    }
    if (this.quickFilterText != ''){
      return true;
    }
    return false;
  }

  //after removing a filter the grid's filter model leaves a filter property that is empty and it needs to be removed
  removePropertiesNotBeingFilteredFromGridFilterModel(filterModelFromGrid){
    if (filterModelFromGrid){
      var keys = Object.keys(filterModelFromGrid);
      for (var i=0; i<keys.length; i++){
        if (keys[i] != 'deptCode' && keys[i] != 'isStock' && keys[i] != 'isPreview'){
          if (filterModelFromGrid[keys[i]].hasOwnProperty('filter') && (filterModelFromGrid[keys[i]].filter == '' || filterModelFromGrid[keys[i]].filter == null)){
            delete filterModelFromGrid[keys[i]];
          }
          else if (filterModelFromGrid[keys[i]].hasOwnProperty('values') && filterModelFromGrid[keys[i]].values.length < 1){
            delete filterModelFromGrid[keys[i]];
          }
        } 
      }
    }
    return filterModelFromGrid;
  }

  showCurrentFiltersThatAreApplied(filterModel) {
    const clonedFilterModel = JSON.parse(JSON.stringify(filterModel));

    //remove the keys that are filtered because of tab clicks
    if (clonedFilterModel.hasOwnProperty('deptCode')) delete clonedFilterModel.deptCode;
    if (clonedFilterModel.hasOwnProperty('isStock')) delete clonedFilterModel.isStock;
    if (clonedFilterModel.hasOwnProperty('isPreview')) delete clonedFilterModel.isPreview;
    if (clonedFilterModel.hasOwnProperty('keywordsFilteredBy')) delete clonedFilterModel.keywordsFilteredBy;
    if (clonedFilterModel.hasOwnProperty('catchWeight')) delete clonedFilterModel.catchWeight;

    if (!(Object.keys(clonedFilterModel).length === 0 && clonedFilterModel.constructor === Object)) {
      var columns = '';
      var numberOfKeys = 0;
      for (var key in clonedFilterModel) {
        numberOfKeys++;
        columns += this.convertCamelCaseToSentenceCaseWithSpaces(key) + ', ';
      }
      columns = columns.replace(/,([^,]*)$/, '$1');
      if (numberOfKeys > 1) {
        columns = columns.replace(/,([^,]*)$/, ' and $1');
        this._messageService.showToastTopRight(columns + ' columns are filtered.');
      }
      else {
        this._messageService.showToastTopRight(columns + ' column is filtered.');
      }
    }
    if (this.quickFilterText != ''){
      this._messageService.showToastTopRight('Quick Filtering on "' + this.quickFilterText + '"');
    }
  }

  convertCamelCaseToSentenceCaseWithSpaces(str) {
    var result = str.replace(/([A-Z])/g, " $1");
    return result.charAt(0).toUpperCase() + result.slice(1);
  }




}
